const PEN_KEY_RE = /^c(\d+)$/;

/** react-hook-form reads a dot in a field name as nesting. */
export function toFormKey(key: string): string {
    return key.split('.').join('__');
}

export function fromFormKey(formKey: string): string {
    return formKey.split('__').join('.');
}

/** A numeric path segment would make react-hook-form build an array of pens. */
export function penKey(cageId: number): string {
    return `c${cageId}`;
}

export function cageIdOf(key: string): number {
    const match = PEN_KEY_RE.exec(key);
    if (match === null) throw new Error(`Not a pen key: ${key}`);
    return Number(match[1]);
}
